<template>
  <ConfigProvider
    :theme="{
      token: {
        colorPrimary: '#ff6b00',
      },
    }"
    ><div class="page-container">
      <div :class="['top-nav', navList[0].active ? 'dark' : 'light']">
        <div class="left">
          <!-- <img
            v-if="navList[0].active"
            class="page-icon"
            src="./assets/img/cmo-1.png"
            alt="cmo中国数学奥林匹克"
          />
          <img
            v-else
            src="./assets/img/cmo-2.png"
            class="page-icon"
            alt="cmo中国数学奥林匹克"
          /> -->
          <div class="page-name">Chinese Mathematical Olympiad</div>
          <div class="page-mini-name">C&nbsp;M&nbsp;O</div>
        </div>
        <div class="right">
          <div class="nav-wrap">
            <template v-for="(item, index) in navList" :key="index">
              <div
                v-if="!item.needLogin || user.isLogin"
                :class="['nav-item', item.active ? 'active' : '']"
                @click="navigateChange(item.path)"
                @mouseenter="showHoverList(index)"
                @mouseleave="hideHoverList(index)"
              >
                {{ item.name }}
                <div
                  v-if="item.hoverList && item.showHoverList"
                  class="dropdown-menu"
                >
                  <div
                    v-for="(hoverItem, hoverIndex) in item.hoverList"
                    :key="hoverIndex"
                    class="dropdown-item"
                    @click.stop="
                      navigateChange(item.path, { type: hoverItem.type })
                    "
                  >
                    {{ hoverItem.name }}
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div v-if="!user.isLogin" class="login" @click="getLogin">登录</div>
          <div v-else-if="user.isLogin" class="login" @click="exitLogin">
            登出
          </div>
          <AlignRightOutlined
            class="mini-nav-icon"
            @click="changeShowNavList"
          />
          <Menu
            v-if="showNavList"
            class="mini-nav-list"
            id="dddddd"
            v-model:openKeys="openKeys"
            mode="inline"
            style="width: 256px"
            :items="items"
            @click="handleClick"
          ></Menu>
        </div>
      </div>
      <router-view class="page-view" />
      <div class="page-footer">
        <div class="support">
          <div class="thanks">
            <div class="name">特别鸣谢</div>
            <div class="list">
              <img
                class="icon"
                src="./assets/img/source-axx.png"
                alt="cmo中国数学奥林匹克特别鸣谢"
              />
              <img
                class="icon"
                src="./assets/img/source-jiukun.png"
                alt="cmo中国数学奥林匹克特别鸣谢"
              />
            </div>
          </div>
          <div class="link">
            <div class="name">友情链接</div>
            <div class="list">
              <img
                class="icon hover-able"
                src="./assets/img/source-math.png"
                @click="changePageLink"
                alt="cmo中国数学奥林匹克-数学会"
              />
            </div>
          </div>
        </div>
        <div class="name web-copyright">
          @Copyright:中国数学会中学数学竞赛委员会
          <a href="https://beian.miit.gov.cn" target="_blank">
            京ICP备17012431号
          </a>
        </div>
      </div>
    </div></ConfigProvider
  >
</template>

<script setup>
import { Menu, ConfigProvider } from "ant-design-vue/es";
import { AlignRightOutlined } from "@ant-design/icons-vue";
import { reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/user";
const user = useUserStore();
try {
  const token = sessionStorage.getItem("cmotoken");
  if (token) user.setLogin(token);
} catch (error) {
  console.log("请登录");
}
const showNavList = ref(false);
const changeShowNavList = () => {
  console.log(168, showNavList.value);
  showNavList.value = !showNavList.value;
};
const openKeys = ref([]);
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
const items = reactive([
  getItem("首页", "/", null),
  getItem("获奖名录", "/result", null, [
    getItem("女子奥赛", { type: 4 }),
    getItem("高中联赛一等奖", { type: 5 }),
    getItem("冬令营", { type: 6 }),
    getItem("集训队一期", { type: 1 }),
    getItem("集训队二期", { type: 2 }),
    getItem("IMO国家队", { type: 3 }),
  ]),
  getItem("关于我们", "/history", null, [
    getItem("中国数学竞赛委员会", { type: "committee" }),
    getItem("承办赛事", { type: "activity" }),
  ]),
  getItem("资料分享", "/resource", null),
  getItem("数据录入", "/database", null),
]);
const handleClick = (e) => {
  console.log("click", e.keyPath);
  const path = e.keyPath[0];
  const query = e.keyPath[1];
  router.push({ path, query });
  const timer = setTimeout(() => {
    changeShowNavList();
    clearTimeout(timer);
  }, 200);
};
const navList = reactive([
  {
    name: "首页",
    path: "/",
    active: true,
    needLogin: false,
  },
  {
    name: "获奖名录",
    path: "/result",
    active: false,
    needLogin: false,
    hoverList: [
      { name: "女子奥赛", type: "4" },
      { name: "高中联赛一等奖", type: "5" },
      { name: "冬令营", type: "6" },
      { name: "集训队一期", type: "1" },
      { name: "集训队二期", type: "2" },
      { name: "IMO国家队", type: "3" },
    ],
    showHoverList: false,
  },
  {
    name: "关于我们",
    path: "/history",
    active: false,
    needLogin: false,
    hoverList: [
      { name: "中国数学竞赛委员会", type: "committee" },
      { name: "承办赛事", type: "activity" },
    ],
    showHoverList: false,
  },
  {
    name: "资料分享",
    path: "/resource",
    active: false,
    needLogin: false,
  },
  {
    name: "数据录入",
    path: "/database",
    active: false,
    needLogin: true,
  },
]);
const navigateChange = (path, params) => {
  router.push({ path, query: params });
};
const router = useRouter();
// 监听路由变化
watch(
  () => router,
  () => {
    const newPath = router.currentRoute.value.path;
    for (let i = 0; i < navList.length; i++) {
      if (navList[i].path == newPath) {
        navList[i].active = true;
      } else {
        navList[i].active = false;
      }
    }
    console.log(74, navList);
  },
  { deep: true, immediate: true }
);
const getLogin = () => {
  router.push({ path: "/login" });
};
const exitLogin = () => {
  user.logout(router);
};
const showHoverList = (index) => {
  if (navList[index].hoverList) {
    navList[index].showHoverList = true;
  }
};
const hideHoverList = (index) => {
  if (navList[index].hoverList) {
    navList[index].showHoverList = false;
  }
};
const changePageLink = () => {
  window.open("https://www.cms.org.cn/");
};
</script>

<style lang="less">
@import "./assets/css/theme.less";
@import "./assets/css/common.less";
body {
  font-family: "Microsoft YaHei UI";
  text-align: center;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
a {
  text-decoration: none;
}
.hover-able {
  cursor: pointer;
}
.page-container {
  // width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .top-nav {
    width: 100%;
    height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10vw;
    box-sizing: border-box;
    .left {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .page-icon {
        margin-right: 14px;
        width: 36px;
        height: 36px;
      }
      .page-name,
      .page-mini-name {
        font-weight: 700;
      }
      .page-mini-name {
        display: none;
      }
      @media (max-width: 580px) {
        .page-name {
          display: none;
        }
        .page-mini-name {
          display: inline-block;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .nav-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 40px;
        .nav-item {
          color: @White;
          text-align: center;
          font-family: "Microsoft YaHei UI";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          cursor: pointer;
          position: relative;
          height: 60px;
          line-height: 60px;
          font-weight: normal;
          &.active {
            font-weight: 700;
          }
          &.active:after {
            content: " ";
            display: block;
            position: absolute;
            width: calc(100% - 10px);
            height: 4px;
            background: @Main;
            bottom: 4px;
            left: 5px;
          }
          .dropdown-menu {
            position: absolute;
            top: 55px;
            left: 0;
            background: @White;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            z-index: 1000;
            display: flex;
            flex-direction: column;
            line-height: 18px;
            .dropdown-item {
              width: fit-content;
              word-break: keep-all;
              color: @Gray-6;
              font-size: 12px;
              padding: 8px 16px;
              cursor: pointer;
              min-width: 100%;
              box-sizing: border-box;
              text-align: left;
              &:hover {
                background: @Background-3;
              }
            }
          }
        }
      }
      .mini-nav-icon {
        display: none;
        font-size: 25px;
      }
      .mini-nav-list {
        display: none;
        position: fixed;
        top: 60px;
        right: 0;
      }
      /* 当屏幕宽度小于600像素时应用的样式 */
      @media (max-width: 1000px) {
        .nav-wrap {
          display: none;
        }
        .mini-nav-icon {
          display: block;
          margin: 0 -5vw 0 5vw;
        }
        .mini-nav-list {
          display: block;
        }
      }
      .login {
        border-radius: 4px;
        border: 1px solid @White;
        width: 100px;
        height: 32px;
        margin-left: 32px;
        color: @White;
        text-align: center;
        font-family: "Microsoft YaHei UI";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 32px;
        cursor: pointer;
      }
    }
    &.dark {
      background: rgba(0, 0, 0, 0.1);
      color: @White;
      .right .nav-wrap .nav-item {
        color: @White;
      }
    }
    &.light {
      position: sticky;
      background: @White;
      border-bottom: 1px solid @Background-4;
      color: @Gray-6;
      .right .nav-wrap .nav-item {
        color: @Gray-6;
      }
      .right .login {
        border-color: @Gray-6;
        color: @Gray-6;
      }
    }
  }
  .page-view {
    flex: 1;
  }
}
.page-footer {
  height: fit-content;
  background: @Background-5;
  padding: 0 10vw;
  .support {
    display: flex;
    border-bottom: 1px solid @Gray-e;
    align-items: center;
    justify-content: flex-start;
    padding: 28px 0;
    gap: 20px 8vw;
    flex-wrap: wrap;
  }
  .thanks,
  .link {
    display: flex;
    align-items: center;
  }
  .name {
    color: @Gray-9;
    font-family: "Microsoft YaHei UI";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-right: 50px;
    text-align: left;
  }
  .list {
    height: fit-content;
    font-size: 0;
  }
  .icon {
    width: auto;
    height: 28px;
    margin-right: 15px;
  }
  .web-copyright {
    padding: 18px 0 24px 0;
    a {
      color: #999999;
      margin-left: 10px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.ant-menu-light .ant-menu-item-selected {
  background-color: @Background-6;
}
.ant-menu-light .ant-menu-submenu-selected > .ant-menu-submenu-title,
.ant-menu-light .ant-menu-item-selected {
  color: @Main;
}
</style>
